module.exports = __webpack_public_path__ + "static/media/postregisterL.4cb17276.jpg";